import { render, staticRenderFns } from "./VaultsList.vue?vue&type=template&id=787ba631"
import script from "./VaultsList.vue?vue&type=script&lang=js"
export * from "./VaultsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports